/* eslint-disable react/prop-types */
import { useEffect, useState, useRef } from 'react'
import splash from './assets/abrePromovidos.jpg'
import './style.scss'

const BTPOpening = ({ interval, cbFinished }) => {
    const [finished, setFinished] = useState(false)
    const timing = useRef(interval * 1000)
    const timer = useRef(null)

    useEffect(() => {
        if (finished) {
            setFinished(false)
            cbFinished()
        }
    }, [cbFinished, finished])

    useEffect(() => {
        timer.current = window.setInterval(
            () => setFinished(true),
            timing.current,
        )
        return () => window.clearInterval(timer.current)
    }, [])

    return <img className='splash' src={splash} alt='' />
}

export default BTPOpening
